(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD', maximumFractionDigits: 0 }).format(cents / 100);
  const translations = {
    alex: [['艾力', 'enduring · capable'], ['安乐', 'peace · joy']],
    emma: [['爱玛', 'beloved · precious'], ['娥曼', 'graceful · enduring']],
    maya: [['美雅', 'beautiful · elegant'], ['麦雅', 'bright · refined']],
    liam: [['力安', 'strength · peace'], ['立安', 'steadfast · calm']]
  };

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const openCart = () => { cartDrawer?.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); };
  const closeCart = () => { cartDrawer?.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open'); };
  document.querySelectorAll('[data-cart-open]').forEach((el) => el.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });

  const menuButton = document.querySelector('[data-menu-toggle]');
  menuButton?.addEventListener('click', () => {
    const open = document.body.classList.toggle('menu-open');
    menuButton.setAttribute('aria-expanded', String(open));
  });

  async function refreshCart() {
    if (!window.Shopify) return;
    const cart = await fetch('/cart.js').then((response) => response.json());
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const content = document.querySelector('[data-cart-content]');
    if (!content) return;
    content.innerHTML = cart.items.length ? `${cart.items.map((item) => `<div class="cart-line"><div><strong>${item.product_title}</strong><small>${Object.values(item.properties || {}).filter(Boolean).slice(0, 3).join(' · ')}</small></div><span>${money(item.final_line_price)}</span></div>`).join('')}<div class="cart-total"><span>Total</span><strong>${money(cart.total_price)}</strong></div><a class="button button--gold button--full" href="/checkout">CHECKOUT</a>` : '<p class="muted">Your bag is empty.</p>';
  }

  document.querySelectorAll('[data-customizer]').forEach((root) => {
    const nameInput = root.querySelector('[data-name-input]');
    const translationList = root.querySelector('[data-translations]');
    const translationProperty = root.querySelector('[data-property-translation]');
    const styleProperty = root.querySelector('[data-property-style]');
    const stoneProperty = root.querySelector('[data-property-stone]');
    const topProperty = root.querySelector('[data-property-top]');
    const previewName = root.querySelector('[data-preview-name]');
    const mark = root.querySelector('[data-mark]');
    const price = root.querySelector('[data-price]');
    const edgeToggle = root.querySelector('[data-edge-toggle]');
    const edgeInput = root.querySelector('[data-edge-input]');
    const topSelect = root.querySelector('[data-top-select]');
    const variantInput = root.querySelector('[data-variant-id]');
    const variantJson = root.querySelector('[data-variant-json]');
    const variants = variantJson ? JSON.parse(variantJson.textContent) : [];
    const submitButton = root.querySelector('button[type="submit"]');
    const addLabel = root.querySelector('[data-add-label]');
    const status = root.querySelector('[data-form-status]');
    const basePrice = Number(root.dataset.basePrice || 11900);

    const selectTranslation = (button) => {
      translationList.querySelectorAll('button').forEach((item) => item.classList.toggle('is-active', item === button));
      translationProperty.value = button.dataset.translation;
      mark.innerHTML = [...button.dataset.translation].map((char) => `<span data-character>${char}</span>`).join('');
      previewName.textContent = `${nameInput.value || 'Your name'} · ${button.dataset.translation}`;
    };
    const updatePrice = () => {
      const stone = root.querySelector('[data-stone].is-active');
      const top = topSelect.options[topSelect.selectedIndex];
      const topValue = top.value;
      const edgeValue = edgeToggle.checked ? 'With edge inscription' : 'No edge inscription';
      const hasEdgeVariants = variants.some((variant) => variant.options?.some((option) => /edge inscription/i.test(option)));
      const matchedVariant = variants.find((variant) => variant.options?.includes(stone?.dataset.stone) && variant.options.includes(topValue) && (!hasEdgeVariants || variant.options.includes(edgeValue)));
      const fallbackPrice = basePrice + Number(stone?.dataset.upcharge || 0) + Number(top?.dataset.upcharge || 0) + (edgeToggle.checked ? 2900 : 0);
      price.textContent = money(matchedVariant?.price ?? fallbackPrice);
      if (matchedVariant && variantInput) variantInput.value = matchedVariant.id;
      if (variants.length && submitButton) {
        submitButton.disabled = !matchedVariant?.available;
        if (addLabel) addLabel.textContent = matchedVariant ? (matchedVariant.available ? 'APPROVE PROOF & ADD TO BAG' : 'SOLD OUT') : 'CONFIGURATION UNAVAILABLE';
      }
      topProperty.value = topValue.replace(/\s*·.*$/, '').replace(/\s*\(.*\)/, '');
    };
    const renderTranslations = () => {
      const key = nameInput.value.trim().toLowerCase();
      const set = translations[key] || [['安印', 'peace · imprint'], ['雅名', 'elegant · name']];
      translationList.innerHTML = set.map(([chars, meaning], index) => `<button type="button" class="${index === 0 ? 'is-active' : ''}" data-translation="${chars}">${chars}<small>${meaning}</small></button>`).join('');
      translationList.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => selectTranslation(button)));
      selectTranslation(translationList.querySelector('button'));
    };
    nameInput.addEventListener('input', renderTranslations);
    translationList.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => selectTranslation(button)));
    root.querySelectorAll('[data-style]').forEach((button) => button.addEventListener('click', () => { root.querySelectorAll('[data-style]').forEach((item) => item.classList.toggle('is-active', item === button)); styleProperty.value = button.dataset.style; mark.classList.toggle('is-relief', button.dataset.style === 'Relief'); }));
    root.querySelectorAll('[data-stone]').forEach((button) => button.addEventListener('click', () => { root.querySelectorAll('[data-stone]').forEach((item) => item.classList.toggle('is-active', item === button)); stoneProperty.value = button.dataset.stone; updatePrice(); }));
    edgeToggle.addEventListener('change', () => { edgeInput.disabled = !edgeToggle.checked; updatePrice(); });
    topSelect.addEventListener('change', updatePrice);
    updatePrice();

    root.querySelector('form')?.addEventListener('submit', async (event) => {
      if (!window.Shopify) { event.preventDefault(); status.textContent = 'Preview mode — connect the theme to Shopify to add this configuration.'; return; }
      event.preventDefault(); status.textContent = 'Adding your design…';
      try { const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(event.currentTarget) }); if (!response.ok) throw new Error('Unable to add'); await refreshCart(); status.textContent = 'Your design is in the bag.'; openCart(); }
      catch (error) { status.textContent = 'Please review your selections and try again.'; }
    });
  });
})();
